module.exports = __webpack_public_path__ + "img/skilllist_1.fd9e98cb.png";